import { useLazyGetPresentationsFiltersQuery } from '@carboncopyco/data';
import { Separator } from '@carboncopyco/ui';
import { capitalize } from '@carboncopyco/utils';
import { useUpdateEffect } from 'ahooks';
import { useEffect } from 'react';
import { SortDropdown } from '../../../UrlStateControls';
import { useUrlState } from '../../../utils';
import { MultiStringFilter } from '../../Controls/MultiStringFilter';
import type { UrlState } from '../../types';
import { useDemoPageProps } from '../DemoPageContext';

type PresentationsControlsProps = { isArchive?: boolean };

export const PresentationsControls = ({
  isArchive,
}: PresentationsControlsProps) => {
  const { organizationId, demoId, workspaceId } = useDemoPageProps();
  const [urlState, setUrlState] = useUrlState<UrlState>({});
  const { query } = urlState;

  const [getPresentationFilters, { data: filters }] =
    useLazyGetPresentationsFiltersQuery();

  useEffect(() => {
    getPresentationFilters({
      workspaces: [workspaceId],
      deletedEntities: isArchive,
      organizationId: Number(organizationId),
      demoId: Number(demoId),
      query,
    });
  }, [
    getPresentationFilters,
    organizationId,
    workspaceId,
    demoId,
    query,
    isArchive,
  ]);

  useUpdateEffect(() => {
    setUrlState({
      companies: undefined,
      creators: undefined,
    });
  }, [organizationId, demoId, query]);

  const creatorOptions =
    filters?.creators?.map((creator) => ({
      id: creator.userId,
      label: capitalize(creator.userName),
    })) || [];

  const companyOptions =
    filters?.companies?.map((company) => ({
      id: company,
      label: company,
    })) || [];

  return (
    <div className="flex p-4 mt-1 gap-3">
      <SortDropdown />
      <div>
        <Separator />
      </div>
      <MultiStringFilter
        capsuleWidth={192}
        placeholder="Created by"
        options={creatorOptions}
        type="creators"
      />
      <MultiStringFilter
        placeholder="Opportunity"
        capsuleWidth={192}
        options={companyOptions}
        type="companies"
      />
    </div>
  );
};
